export const mk = {
    // Login screen
    modal_login_capital: 'ПРИЈАВУВАЊЕ',
    placeholder_email_address: 'е-пошта',
    placeholder_password: 'лозинка',
    tooltip_forgot_password: 'Заборавена лозинка?',
    log_in: 'Пријавување',

    // Register screen
    modal_signup_capital: 'РЕГИСТРИРАЊЕ',
    placeholder_repeat_password: 'Повторена лозинка',
    agree: 'Се согласувам со ',
    terms: 'Условите',
    modal_register_capital: 'РЕГИСТРИРАЊЕ',
    full_name: 'Целосно име',

    // Price options
    choose_price: 'ИЗБОР НА ЦЕНА',
    subscription_price: 'Претплатa',
    asset_price: 'Asset',
    paywall_subscription_text:
        'Можете да ја откажете претплатата во секое време.',
    modal_back: 'НАЗАД',
    next_button: 'СЛЕДНО',

    // Payments screen
    pay: 'PAY',
    pay_with: 'PAY WITH PAYPAL',
    credit_card: 'credit card',
    payment_pay: 'Плати',
    payment_price: 'Цена',
    placeholder_voucher_code: 'Код на ваучерот',
    placeholder_voucher: 'додај го кодот',
    card_number: 'број на картичката',
    cardholder_name: 'името на картичката',

    // Forgot password
    forgot_pass_text: "We'll email a link to reset your password.",
    remember_pass: 'Remember password?',
    reset: 'РЕСЕТИРАЈ',

    // Set new password
    modal_enter_your_new_password: 'Внесете нова лозинка.',
    modal_please_check_your_email:
        'Проверете ја Вашата е-пошта и копирајте го пратениот токен за да продолжите понатаму.',
    placeholder_token: 'токен',
    new_password: 'нова лозинка',
    repeat_new_password: 'Повторена нова лозинка',
    cancel: 'откажи',
    set: 'SET',

    // Change password
    update: 'ажурирај',
    change_pass: 'Промени ја лозиннката.',

    // Account
    user_menu_my_account: 'Мој профил',
    member_since: 'Член од ',
    purchases: 'My purchases',
    subscriptions: 'Мои претплати',
    account_details: 'Детали за профилот',
    export_data: 'Export my data',
    delete_account: 'Избриши фо профилот',

    // Purchases/Subscriptions
    purchases_link: 'Purchases',
    subscriptions_link: 'Претплати',
    subscriptions_text:
        'These are all the assets you have purchased and how long you have access to it.',
    purchase_history: 'Purchase history',
    purchased: 'Purchased',
    name: 'име',
    active: 'активни',
    inactive: 'inactive',
    canceled: 'откажени',
    type: 'Тип',
    next_transaction: 'следна трансакција',
    cancel_subscription: 'Откажиа ја претплатата >',
    subscriptions_active: 'Активни претлати',
    expires_at: 'Истекува на',
    no_more_subscriptions: 'Нема повеќе претплати.',
    no_available_subscriptions: 'Нема повеќе достапни претплати.',
    no_more_active_accesses: 'Нема повеќе активни претплати.',
    no_more_inactive_accesses: 'Нема повеќе активни претплати.',
    no_available_active_accesses: 'Нема повеќе достапни активни претплати.',
    no_available_inactive_accesses: 'Нема повеќе достапни неактивни претплати.',
    free_trial: 'Free Trial',
    cancel_subscription_header:
        'Are you sure you want to cancel your subscription?',
    cancel_subscription_paragraph_first:
        'This will end your subscription for the ',
    cancel_subscription_paragraph_second:
        'You will still have access to everything until the active period ends on the ',
    cancel_subscription_confirm: 'Yes, cancel',
    will_end: 'Subscription will end:',

    // Export data screen
    export_question: 'Are you sure you want to export your account data?',
    export: 'export',

    // Delete account screen
    delete_question: 'Дали сте сигурни дека сакате да го избришете профилот?',
    delete: 'бриши',
    confirm: 'ПОТВРДИ',

    // Inputs validation
    required_field: 'Required field',
    email_field: 'внесете валиден емаил',
    number_field: 'Вредноста треба да биде број.',
    matchPass: 'двете лозинки треба да бидат исти.',
    minpass_field: 'must be at least 8 characters long',
    minname_field: 'must be at least 2 characters long',

    // Footer
    modal_terms: 'Услови',
    modal_privacy: 'Политиката на приватност',
    modal_more: 'ПОВЕЌЕ',
    modal_faq: 'FAQ',
    modal_protected: 'Што е ова?',
    logout: 'Одјави се',
    details: 'Детали за профилот',
    preview_protected_by_inplayer: 'Заштитено од ',
    modal_support: 'Поддршка',

    dlc_download: 'download',
};



// WEBPACK FOOTER //
// ./src/i18n/macedonian.js